import React, { useState, useEffect, useRef } from 'react'
import { Container, Button, Row, Col } from "react-bootstrap";
import InputGroup from 'react-bootstrap/InputGroup';
import "bootstrap/dist/css/bootstrap.min.css";
import { XLg } from "react-bootstrap-icons";
import Form from "react-bootstrap/Form";
import styles from "./SummaryFilterBox.module.scss";

const SummaryFilterBox = (props) => {
    const [selectedStatus, setSelectedStatus] = useState([]);                       // all the selected value in status
    const filterBoxRef = useRef(null);

    // Function to handle "All Status" checkbox
    const handleAllStatusChange = (isChecked) => {
        setSelectedStatus(isChecked ? props.statusData.map((status) => status.id) : []);
    };


    const [searchCustomerValue, setSearchCustomerValue] = useState(""); // Searched Value from Customer
    const clearFilterSearchCustomer = () => { // Clear Filter Box Search Input
        setSearchCustomerValue("");
    }

    const clearFilterBox = () => {

        if (props.customerId && props.customerId !== null) {
            const element = document.getElementById(props.customerId);
            if (element) {
                element.checked = false;
            }
        };
        if (props.status && props.status !== null) {
            const element = document.getElementById(props.status);
            if (element) {
                element.checked = false;
            }
        };

        setSelectedStatus([]);
        props.setScrollToDivTop(true);
        props.setTableFilterApplied(false);
        props.setStatus(null);
        props.setCustomerId(null);
        props.setPageNo(1);
        props.GetTableData(1, props.pageSize, props.searchValueTable, null, props.sortCol, props.sortDir, props.serviceId, null);
        props.setFilterFlag(false);
    }

    useEffect(() => {
        (props.status != null || props.status != undefined) ? setSelectedStatus(props.status) : setSelectedStatus([]);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            const filterButton = document.getElementById('filterblock');
            const filterButtonActive = document.querySelector('.filter-black-active');
            
            const isFilterClick = filterButton?.contains(event.target) || 
                                filterButtonActive?.contains(event.target);
    
            if (isFilterClick) {
                return;
            }
    
            // If click is outside filter box and not on filter button, close the box
            if (filterBoxRef.current && !filterBoxRef.current.contains(event.target)) {
                props.setShowFilterBox(false);
            }
        };
    
        document.addEventListener('mousedown', handleClickOutside);
    
        // Cleanup
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
        }, []);

    return (
        <div className="filter-box filter-box-mid dashboard-filters" ref={filterBoxRef}>
            <Container>
                <Col className="d-flex justify-content-between d-md-none align-items-center px-8 flex-grow-0">
                    <h2>Filters</h2>
                    <XLg size={16} onClick={() => props.setShowFilterBox(false)} />
                </Col>
                <Row className={`mb-3 mobile-filter-row ${styles['ipad-pro-filterbox']}`}>
                    <Col className={`filter-column ${styles['filter-column-height']}`}>
                        <h3 className="mb-3">Customer</h3>
                        <div>
                            <InputGroup className="search-input-group mb-3">
                                <Form.Control
                                    placeholder="Search"
                                    aria-label="Search"
                                    aria-describedby="search"
                                    value={searchCustomerValue}
                                    onChange={(e) => setSearchCustomerValue(e.target.value)}
                                />
                                <InputGroup.Text class="clear-search" onClick={clearFilterSearchCustomer}><span>&nbsp;</span></InputGroup.Text>
                            </InputGroup>
                            <div className="filter-options">

                                {
                                    <>
                                        {
                                            props.customerData &&
                                            props.customerData.filter(option => (option.name).toLowerCase().includes(searchCustomerValue.toLowerCase())).map((filteredOption) => {
                                                {
                                                    return (
                                                        <>
                                                            <Form.Check // prettier-ignore
                                                                key={filteredOption.id}
                                                                type={'radio'}
                                                                id={filteredOption.id}
                                                                label={filteredOption.name}
                                                                name="customerGroup"
                                                                value={filteredOption.id}
                                                                aria-label={filteredOption.name}
                                                                defaultChecked={filteredOption.id == props.customerId ? true : false}
                                                                onChange={(e) => {
                                                                    (e.target.value === "default") ? props.setCustomerId(null) : props.setCustomerId(e.target.id);
                                                                }
                                                                }
                                                            />
                                                        </>
                                                    )
                                                }
                                            })
                                        }
                                    </>
                                }

                                {
                                    !props.customerData && <p>Loading...</p>
                                }
                            </div>
                        </div>

                    </Col>
                    <Col className="filter-column">
                        <h3 className="mb-3">Status</h3>
                        <div>
                            <div className="filter-options">
                                <>
                                    {props.statusData && props.statusData.length > 0 && <Form.Check
                                        className="mb-2"
                                        type="radio"
                                        id={`statuses-all`}
                                        label="All Statuses"
                                        checked={(selectedStatus.length === props.statusData.length)}
                                        onChange={(e) => handleAllStatusChange(e.target.checked)}
                                    />}
                                    {props.statusData && props.statusData.length > 0 &&
                                        props.statusData.map((statusItem) => {
                                            return (
                                                <Form.Check
                                                    className="mb-2"
                                                    key={statusItem.id}
                                                    type="radio"
                                                    id={`status-${statusItem.id}`}
                                                    label={statusItem.name}
                                                    checked={selectedStatus.includes(statusItem.id) && !((selectedStatus.length === props.statusData.length))}
                                                    onChange={() => setSelectedStatus(statusItem.id)}
                                                />
                                            );
                                        })}
                                    {
                                        !props.statusData && <>Loading...</>

                                    }
                                </>
                            </div>
                        </div>

                    </Col>
                </Row>
                <Row className="actions-row">
                    <Col className="d-flex justify-content-end">
                        {(!props.customerId && selectedStatus.length == 0) &&
                            <Button
                                className="btn btn-lg mx-3"
                                variant="light"
                                disabled
                            >
                                Clear
                            </Button>
                        }
                        {(props.customerId || selectedStatus.length > 0) &&
                            <Button
                                className="btn btn-lg mx-3 btn-border-light"
                                variant="light"
                                onClick={clearFilterBox}>
                                Clear
                            </Button>
                        }
                        {(props.customerId || selectedStatus.length > 0) &&
                            <Button
                                className="btn btn-lg"
                                variant="primary"
                                onClick={() => {
                                    props.setStatus(selectedStatus);
                                    props.setScrollToDivTop(true);
                                    props.setTableFilterApplied(true);
                                    props.setPageNo(1);
                                    props.GetTableData(1, props.pageSize, props.searchValueTable, selectedStatus, props.sortCol, props.sortDir, props.serviceId, props.customerId, true, false);
                                    props.setShowFilterBox(false);
                                    props.setFilterFlag(true);
                                }
                                }
                            >
                                Apply
                            </Button>
                        }
                        {(!props.customerId && selectedStatus.length === 0) &&
                            <Button
                                className="btn btn-lg"
                                variant="light"
                                disabled
                            >
                                Apply
                            </Button>
                        }
                    </Col>
                </Row>
            </Container>
        </div >
    )
}

export default SummaryFilterBox